import { FC } from 'react';
import classnames from 'classnames';
import styles from './styles/CheckoutStepsShimmer.scss';
import { ShimmerCol } from './shared/ShimmerCol';

import { GridRow } from 'dibs-elements/exports/Grid';

type Props = {
    hideDivider?: boolean;
};

export const CheckoutStepsShimmer: FC<Props> = props => {
    const { hideDivider } = props;

    return (
        <div
            data-tn="checkout-shimmer"
            className={classnames(styles.shimmer, { [styles.divider]: !hideDivider })}
        >
            <GridRow>
                <ShimmerCol desktop={3} mobile={8} className={styles.top} />
                <ShimmerCol desktop={12} className={styles.middle} />
                <ShimmerCol desktop={6} className={styles.middle} />
                <ShimmerCol desktop={6} className={styles.middle} />
                <ShimmerCol desktop={12} className={styles.middle} />
                <ShimmerCol desktop={6} className={styles.middle} />
            </GridRow>
            <GridRow>
                <ShimmerCol desktop={6} className={styles.bottom} />
            </GridRow>
        </div>
    );
};
